export function getUrlParameter(name) {
    const pageUrl = window.location.search.substring(1);
    const keyValues = pageUrl.split('&');

    let parameterName;

    for (let i = 0; i < keyValues.length; i++) {
        parameterName = keyValues[i].split('=');

        if (name === parameterName[0]) {
            return typeof parameterName[1] === undefined ? true : decodeURIComponent(parameterName[1]);
        }
    }

    return undefined;
}

export async function waitForOutletToBeLoaded(outletCallback) {
    return await new Promise((resolve, reject) => {
        const interval = setInterval(() => {
            if (!outletCallback().__stimulusLazyController) {
                clearInterval(interval);
                resolve();
            }
        }, 100);
    });
}